import { createActions } from '../utils/actions';

const { actions: connectProfile } = createActions('connectProfile')
  .add('bootstrap')
  .add('cleanUp')
  .addAsync('getFilters')
  .addAsync('getListings')
  .addAsync('getStatuses')
  .add('loadMore')
  .add('setConnectedProducts')
  .add('setFilter')
  .add('setStatus')
  .add('toggleProduct')
  .addAsync('toggleAllProducts');

export default connectProfile;
